var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccordionArrow = function SvgAccordionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.167 5.859a.833.833 0 0 1-1.175 0L5 2.909l-2.95 2.95A.833.833 0 1 1 .875 4.675l3.533-3.533a.833.833 0 0 1 1.184 0l3.575 3.533a.833.833 0 0 1 0 1.184Z"
  })));
};
export default SvgAccordionArrow;